import React from 'react';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import About4 from './../Elements/About4';
// import Specialization from './../Elements/Specialization';
import Team2 from './../Elements/Team2';
import AboutSummary from './../Elements/AboutSummary';

var bnrimg = require('./../../images/banner/1.jpg');

class About extends React.Component {
    render() {
        return (
            <>

                <Header />
                <div className="page-content">
                    <Banner title="Redefining Precision in Quantity Takeoffs for a Global Construction Industry!" pagename="About Us" bgimage={bnrimg}/>
                    <About4 />
                    {/* <Specialization /> */}
                    <Team2 />
                    <AboutSummary />

                </div>

                <Footer />

            </>
        );
    };
};

export default About;